import { DEFAULT_CURRENCY } from "@faire/retailer-visitor-shared/consts/DEFAULT_CURRENCY";
import { isPrePackProduct, isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { sum } from "@faire/retailer-visitor-shared/lib/sum";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { moneyOrZero } from "@faire/web--source/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import minBy from "lodash/minBy";
export var getOptionAvailableUnits = function(product, option) {
    if (product.allow_sales_when_out_of_stock) {
        return Number.POSITIVE_INFINITY;
    }
    var _option_available_units;
    return (_option_available_units = option === null || option === void 0 ? void 0 : option.available_units) !== null && _option_available_units !== void 0 ? _option_available_units : Number.POSITIVE_INFINITY;
};
// product utilities
export var getProductAvailableUnits = function(product) {
    return product.options ? sum(product.options.map(function(option) {
        return getOptionAvailableUnits(product, option);
    })) : 0;
};
var _product_options;
export var getProductImages = function(product) {
    var productOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (_product_options = product === null || product === void 0 ? void 0 : product.options) !== null && _product_options !== void 0 ? _product_options : [];
    var _product_images, _imagesByType_HERO;
    if (!product) {
        return [];
    }
    // Used to dedup photos that have the same URL because both the product and the option point to
    // the same image.
    var imagesByType = {
        HERO: [],
        PRODUCT: [],
        PACKAGING: [],
        LIFESTYLE: [],
        OTHER: []
    };
    var imageUrls = new Set();
    (_product_images = product.images) === null || _product_images === void 0 ? void 0 : _product_images.forEach(function(image) {
        if (image.url) {
            if (imageUrls.has(image.url)) {
                return;
            }
            if (image.type) {
                var _imagesByType_image_type;
                (_imagesByType_image_type = imagesByType[image.type]) === null || _imagesByType_image_type === void 0 ? void 0 : _imagesByType_image_type.push(image);
            } else {
                var _imagesByType_OTHER;
                (_imagesByType_OTHER = imagesByType.OTHER) === null || _imagesByType_OTHER === void 0 ? void 0 : _imagesByType_OTHER.push(image);
            }
            imageUrls.add(image.url);
        }
    });
    productOptions === null || productOptions === void 0 ? void 0 : productOptions.forEach(function(productOption) {
        var _productOption_images;
        (_productOption_images = productOption.images) === null || _productOption_images === void 0 ? void 0 : _productOption_images.forEach(function(image) {
            if (image.url) {
                if (imageUrls.has(image.url)) {
                    return;
                }
                if (image.type) {
                    var _imagesByType_image_type;
                    (_imagesByType_image_type = imagesByType[image.type]) === null || _imagesByType_image_type === void 0 ? void 0 : _imagesByType_image_type.push(image);
                } else {
                    var _imagesByType_OTHER;
                    (_imagesByType_OTHER = imagesByType.OTHER) === null || _imagesByType_OTHER === void 0 ? void 0 : _imagesByType_OTHER.push(image);
                }
                imageUrls.add(image.url);
            }
        });
    });
    var _imagesByType_OTHER, _imagesByType_PRODUCT, _imagesByType_PACKAGING, _imagesByType_LIFESTYLE, _imagesByType_HERO_concat;
    var imageList = (_imagesByType_HERO_concat = (_imagesByType_HERO = imagesByType.HERO) === null || _imagesByType_HERO === void 0 ? void 0 : _imagesByType_HERO.concat((_imagesByType_OTHER = imagesByType.OTHER) !== null && _imagesByType_OTHER !== void 0 ? _imagesByType_OTHER : [], (_imagesByType_PRODUCT = imagesByType.PRODUCT) !== null && _imagesByType_PRODUCT !== void 0 ? _imagesByType_PRODUCT : [], (_imagesByType_PACKAGING = imagesByType.PACKAGING) !== null && _imagesByType_PACKAGING !== void 0 ? _imagesByType_PACKAGING : [], (_imagesByType_LIFESTYLE = imagesByType.LIFESTYLE) !== null && _imagesByType_LIFESTYLE !== void 0 ? _imagesByType_LIFESTYLE : [])) !== null && _imagesByType_HERO_concat !== void 0 ? _imagesByType_HERO_concat : [];
    return imageList;
};
var _product_options1;
export var getBestProductImage = function(product) {
    var productOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (_product_options1 = product === null || product === void 0 ? void 0 : product.options) !== null && _product_options1 !== void 0 ? _product_options1 : [];
    if (!product) {
        return undefined;
    }
    var imageList = getProductImages(product, productOptions);
    return imageList.length > 0 ? imageList[0] : undefined;
};
export var getProductOptionImage = function(product, optionToken) {
    var _product_options;
    var option = (_product_options = product.options) === null || _product_options === void 0 ? void 0 : _product_options.find(function(option) {
        return option.token === optionToken;
    });
    if (option && option.images && option.images.length) {
        return option.images[0];
    }
    return getBestProductImage(product) || undefined;
};
export var getLeastExpensiveOptionByRetailPrice = function(options) {
    return minBy(options, function(option) {
        var _option_retail_price;
        var _option_retail_price_amount_cents;
        return (_option_retail_price_amount_cents = (_option_retail_price = option.retail_price) === null || _option_retail_price === void 0 ? void 0 : _option_retail_price.amount_cents) !== null && _option_retail_price_amount_cents !== void 0 ? _option_retail_price_amount_cents : option.retail_price_cents;
    });
};
var leastExpensiveOption = function(product) {
    return minBy(product.options, function(option) {
        var _option_wholesale_price, _option_retail_price;
        var _option_wholesale_price_amount_cents, _ref, _ref1;
        return (_ref1 = (_ref = (_option_wholesale_price_amount_cents = (_option_wholesale_price = option.wholesale_price) === null || _option_wholesale_price === void 0 ? void 0 : _option_wholesale_price.amount_cents) !== null && _option_wholesale_price_amount_cents !== void 0 ? _option_wholesale_price_amount_cents : option.wholesale_price_cents) !== null && _ref !== void 0 ? _ref : (_option_retail_price = option.retail_price) === null || _option_retail_price === void 0 ? void 0 : _option_retail_price.amount_cents) !== null && _ref1 !== void 0 ? _ref1 : option.retail_price_cents;
    });
};
export var hasOptions = function(product) {
    return product.options !== undefined && product.options.length > 0;
};
export var getProductLevelPromotion = function(product, productOption) {
    if (!product) {
        return;
    }
    var option = productOption !== null && productOption !== void 0 ? productOption : leastExpensiveOption(product);
    return option === null || option === void 0 ? void 0 : option.wholesale_promo_price;
};
export var getProductOptionProperty = function(product, propertyName) {
    if (product.options) {
        var option = leastExpensiveOption(product);
        return (option === null || option === void 0 ? void 0 : option[propertyName]) || product[propertyName];
    }
    return product[propertyName];
};
export var getProductOptionWholesalePrice = function(product, productOption) {
    if (!product) {
        return moneyOrZero(undefined);
    }
    var option = productOption !== null && productOption !== void 0 ? productOption : leastExpensiveOption(product);
    if (option && isPrePackProductOption(option) && option.unit_count_per_cart_item) {
        var _option_wholesale_price, _option_wholesale_price1;
        var _option_wholesale_price_amount_cents, _option_wholesale_price_currency;
        return IFaireMoney.build({
            amount_cents: ((_option_wholesale_price_amount_cents = (_option_wholesale_price = option.wholesale_price) === null || _option_wholesale_price === void 0 ? void 0 : _option_wholesale_price.amount_cents) !== null && _option_wholesale_price_amount_cents !== void 0 ? _option_wholesale_price_amount_cents : 0) / option.unit_count_per_cart_item,
            currency: (_option_wholesale_price_currency = (_option_wholesale_price1 = option.wholesale_price) === null || _option_wholesale_price1 === void 0 ? void 0 : _option_wholesale_price1.currency) !== null && _option_wholesale_price_currency !== void 0 ? _option_wholesale_price_currency : DEFAULT_CURRENCY
        });
    }
    var _option_wholesale_price2, _ref;
    return (_ref = (_option_wholesale_price2 = option === null || option === void 0 ? void 0 : option.wholesale_price) !== null && _option_wholesale_price2 !== void 0 ? _option_wholesale_price2 : product.max_option_wholesale_price) !== null && _ref !== void 0 ? _ref : IFaireMoney.build({
        amount_cents: 0,
        currency: DEFAULT_CURRENCY
    });
};
export var getProductOptionRetailPrice = function(product, productOption) {
    if (!product) {
        return moneyOrZero(undefined);
    }
    var option = productOption !== null && productOption !== void 0 ? productOption : leastExpensiveOption(product);
    if (option && isPrePackProductOption(option) && option.unit_count_per_cart_item) {
        var _option_retail_price, _option_retail_price1;
        var _option_retail_price_amount_cents, _option_retail_price_currency;
        return IFaireMoney.build({
            amount_cents: ((_option_retail_price_amount_cents = (_option_retail_price = option.retail_price) === null || _option_retail_price === void 0 ? void 0 : _option_retail_price.amount_cents) !== null && _option_retail_price_amount_cents !== void 0 ? _option_retail_price_amount_cents : 0) / option.unit_count_per_cart_item,
            currency: (_option_retail_price_currency = (_option_retail_price1 = option.retail_price) === null || _option_retail_price1 === void 0 ? void 0 : _option_retail_price1.currency) !== null && _option_retail_price_currency !== void 0 ? _option_retail_price_currency : DEFAULT_CURRENCY
        });
    }
    var _option_retail_price2, _ref;
    return (_ref = (_option_retail_price2 = option === null || option === void 0 ? void 0 : option.retail_price) !== null && _option_retail_price2 !== void 0 ? _option_retail_price2 : product.max_option_retail_price) !== null && _ref !== void 0 ? _ref : IFaireMoney.build({
        amount_cents: 0,
        currency: DEFAULT_CURRENCY
    });
};
export var getCaseSizeText = function(product, strictLocalize) {
    var caseSize = getProductOptionProperty(product, "unit_multiplier");
    var prePacksAvailable = isPrePackProduct(product);
    var isOpenSizingProduct = !prePacksAvailable && !!product.per_style_min_order_quantity;
    if (prePacksAvailable) {
        return strictLocalize({
            id: "qHncLW",
            defaultMessage: [
                {
                    type: 0,
                    value: "Prepacks Available"
                }
            ]
        });
    }
    if (isOpenSizingProduct) {
        return strictLocalize({
            id: "qLioWU",
            defaultMessage: [
                {
                    type: 0,
                    value: "Min Qty "
                },
                {
                    type: 1,
                    value: "minimumOrderQuantity"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            minimumOrderQuantity: product.per_style_min_order_quantity
        }));
    }
    return strictLocalize({
        id: "VA4Ssu",
        defaultMessage: [
            {
                type: 0,
                value: "Case of "
            },
            {
                type: 1,
                value: "caseSize"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        caseSize: caseSize
    }));
};
